import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Aminities = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [amenitiesList, setAmenitiesList] = useState([]);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/amenties")
      .then(res => res.json())
      .then(resData => {
        if (resData.status && Array.isArray(resData.data)) {
          const limitedAmenities = resData.data.slice(0, 20);
          setAmenitiesList(limitedAmenities);
        } else {
          console.error("Unexpected response format", resData);
        }
      })
      .catch(err => console.error("Failed to fetch amenities:", err));
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h5 style={{ fontSize: '30px' }}>
        <span style={{ color: 'red' }}>AMENITIES</span>
      </h5>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
          marginTop: '20px',
        }}
      >
        {amenitiesList.map((item, index) => {
          const imageUrl = `https://adinathbuilder.com/admin/public/${item.image_path}`;

          return (
            <motion.div
              key={index}
              style={{
                border: '1px solid #ccc',
                borderRadius: '25px',
                padding: '15px',
                width: isMobile ? '100%' : '280px',
                maxWidth: '100%',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                textAlign: 'center',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
              }}
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{
                duration: 0.5,
                ease: 'easeInOut',
                delay: index * 0.05,
                type: 'spring',
                stiffness: 120,
                damping: 10,
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '153px',
                  overflow: 'hidden',
                  borderRadius: '15px',
                  marginBottom: '10px',
                }}
              >
                <img
                  src={imageUrl}
                  alt={`Amenity ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </div>
              <div>
                <p style={{ textAlign: 'left', fontSize: '15px' }}>✓ {item.description}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Aminities;